// extracted by mini-css-extract-plugin
export default {"container":"Tooltip_container__Ph2UQ","button":"Tooltip_button__ZE24o","text":"Tooltip_text__xlJWA"};